/**
 * Angular imports.
 */
import { Component, Input, ViewChild, OnDestroy, ChangeDetectionStrategy, ElementRef, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';

/**
 * Service imports.
 */
import { TimeService } from './../../services/timer.service';
import { OnChange } from 'src/app/custom-decorators/ngOnchanges.Decorator';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * Used to play the video stories.
 */
@Component({
  selector: 'app-story-video',
  templateUrl: './story-video.component.html',
  styleUrls: ['./story-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoryVideoComponent implements OnDestroy,OnInit {

  /**
   * Create the element reference for the video player.
   */
  @ViewChild('videoEl', { static: false }) videoEl: ElementRef;

  /**
   * Source for the video.
   */
  @Input() readonly src: string;
  /**
   * Source for the video.
   */
  @Input() readonly videoId: string;

  /**
   * if text is present in story
   */
  @Input() typingText: string;

  /**
   * tag user list
   */
  @Input() tagUsers = [];

  /**
   * Mute status for the video.
   */
  @Input() public isMuted = false;


  @OnChange<void>('onActiveStoryIndexChange')
  @Input() storyCode;
  /**
   * emit duration of video
   */
  @Output() emitDuration: EventEmitter<number> = new EventEmitter();
  /**
   * Emit the generated meta.
   */
  @Output() emitGenerateMeta: EventEmitter<any> = new EventEmitter();
  /**
   * toggle progress counter
   */
  @Output() emitToggleProgressCounter: EventEmitter<boolean> = new EventEmitter();

  @Output() onGenrateTagMeta: EventEmitter<any> = new EventEmitter();

  /**
   * on meta emit
   */
  @Output() profileRedirectEmit: EventEmitter<any> = new EventEmitter();

  @Output() lockScreen: EventEmitter<any> = new EventEmitter();
  /**
   * Unsubscribe the subscription.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * video playing flag
   */
  public isVideoPlaying = false;
  /**
   * video
   */
  public videoElem: HTMLVideoElement;
  isTagMeta: boolean;
  currentTag: any;

  /**
   * necessary instance.
   */
  constructor(private timerService: TimeService,
    private chg: ChangeDetectorRef) {
    this.setMuteStatus();
  }
  onActiveStoryIndexChange(): void {
    this.startVideo();
  }

  /**
   * Set the mute status for the video.
   */
  setMuteStatus(): void {
    this.subscriptions.add(this.timerService.getTimerStatus()
      .pipe(distinctUntilChanged())
      .subscribe((status: boolean) => {
        if (status) {
          this.videoEl?.nativeElement?.play();
        } else {
          this.videoEl?.nativeElement?.pause();
        }
      }));
  }
  /**
   * 
   * @param event function to generate meta on tag 
   */
  generateMeta(event): void {
    this.emitGenerateMeta.emit(event);
  }

  /**
   * Unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
  generateTagMeta(event) {
    this.isTagMeta = true;
    this.currentTag = event;
    this.lockScreen.emit(true);
    this.emitGenerateMeta.emit(event);
    this.chg.markForCheck();
  }
  /**
   * restore view 
   */
  restoreView(): void {
    if (this.isTagMeta === true) {
      this.isTagMeta = false;
      this.currentTag === null;
      this.generateMeta(false);
      this.lockScreen.emit(false);
      this.chg.markForCheck();
      this.chg.detectChanges();
    }
  }
  onMeta(event): void {
    this.profileRedirectEmit.emit(event);
  }
  startVideo(): void  {
    if (this.videoElem) {
      this.isVideoPlaying = false;
      this.timerService.stopTimer();
      this.emitToggleProgressCounter.emit(true);
      this.videoElem.load();
    }
  }
  ngOnInit(): void {
     this.videoElem = document.querySelector('video');
     this.timerService.stopTimer();
    this.emitToggleProgressCounter.emit(true);
    this.videoElem.addEventListener('loadeddata', (event) => {
     this.isVideoPlaying = true;
     this.timerService.resetTimer();
     this.emitToggleProgressCounter.emit(true);
     const duration = this.videoEl?.nativeElement?.duration;
     this.emitDuration.emit(duration);
     this.timerService.startCount();
     this.chg.markForCheck();
    });
  }
}
